import { Attr, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type OrganisationReportFilteredSpec from "./OrganisationReportFilteredSpec";

@Model()
class FilteredSpecStreams extends ApplicationRecord {
  static jsonapiType = "filtered_spec_streams";

  @HasOne()
  filteredSpec: OrganisationReportFilteredSpec;

  @Attr() filteredSpecId: number;

  @Attr() filterSetId: number;

  @Attr() streamId: number;
}

export default FilteredSpecStreams;
